import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "media" ];
  videoContainer;
  videoOverlayToggle;

  connect() {
    this.videoOverlayToggle = document.querySelector('#video-overlay .top-nav-btn-burger');
    this.videoContainer = document.querySelector('#video-overlay-container');
  }

  play(event) {
    event.preventDefault();

    if (this.hasMediaTarget && this.videoOverlayToggle !== null && this.videoContainer !== null) {
      let evt = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      });
      this.videoOverlayToggle.dispatchEvent(evt);
      this.videoContainer.innerHTML = this.mediaTarget.innerHTML;
    }
  }
}
